export const countryCodes = [
  {
    name: 'US',
    code: '1',
    label: 'United States of America',
  },
  {
    name: 'AF',
    code: '93',
    label: 'Afghanistan',
  },
  {
    name: 'AL',
    code: '355',
    label: 'Albania',
  },
  {
    name: 'DZ',
    code: '213',
    label: 'Algeria',
  },
  {
    name: 'AS',
    code: '1',
    label: 'American Samoa',
  },
  {
    name: 'AD',
    code: '376',
    label: 'Andorra',
  },
  {
    name: 'AO',
    code: '244',
    label: 'Angola',
  },
  {
    name: 'AI',
    code: '1',
    label: 'Anguilla',
  },
  {
    name: 'AQ',
    code: '672',
    label: 'Antarctica',
  },
  {
    name: 'AG',
    code: '1',
    label: 'Antigua and Barbuda',
  },
  {
    name: 'AR',
    code: '54',
    label: 'Argentina',
  },
  {
    name: 'AM',
    code: '374',
    label: 'Armenia',
  },
  {
    name: 'AW',
    code: '297',
    label: 'Aruba',
  },
  {
    name: 'AU',
    code: '61',
    label: 'Australia',
  },
  {
    name: 'AT',
    code: '43',
    label: 'Austria',
  },
  {
    name: 'AZ',
    code: '994',
    label: 'Azerbaijan',
  },
  {
    name: 'BS',
    code: '1',
    label: 'Bahamas',
  },
  {
    name: 'BH',
    code: '973',
    label: 'Bahrain',
  },
  {
    name: 'BD',
    code: '880',
    label: 'Bangladesh',
  },
  {
    name: 'BB',
    code: '1',
    label: 'Barbados',
  },
  {
    name: 'BY',
    code: '375',
    label: 'Belarus',
  },
  {
    name: 'BE',
    code: '32',
    label: 'Belgium',
  },
  {
    name: 'BZ',
    code: '501',
    label: 'Belize',
  },
  {
    name: 'BJ',
    code: '229',
    label: 'Benin',
  },
  {
    name: 'BM',
    code: '1',
    label: 'Bermuda',
  },
  {
    name: 'BT',
    code: '975',
    label: 'Bhutan',
  },
  {
    name: 'BO',
    code: '591',
    label: 'Bolivia (Plurinational State of)',
  },
  {
    name: 'BQ',
    code: '599',
    label: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    name: 'BA',
    code: '387',
    label: 'Bosnia and Herzegovina',
  },
  {
    name: 'BW',
    code: '267',
    label: 'Botswana',
  },
  {
    name: 'BV',
    code: '47',
    label: 'Bouvet Island',
  },
  {
    name: 'BR',
    code: '55',
    label: 'Brazil',
  },
  {
    name: 'IO',
    code: '246',
    label: 'British Indian Ocean Territory',
  },
  {
    name: 'BN',
    code: '673',
    label: 'Brunei Darussalam',
  },
  {
    name: 'BG',
    code: '359',
    label: 'Bulgaria',
  },
  {
    name: 'BF',
    code: '226',
    label: 'Burkina Faso',
  },
  {
    name: 'BI',
    code: '257',
    label: 'Burundi',
  },
  {
    name: 'CV',
    code: '238',
    label: 'Cabo Verde',
  },
  {
    name: 'KH',
    code: '855',
    label: 'Cambodia',
  },
  {
    name: 'CM',
    code: '237',
    label: 'Cameroon',
  },
  {
    name: 'CA',
    code: '1',
    label: 'Canada',
  },
  {
    name: 'KY',
    code: '1',
    label: 'Cayman Islands',
  },
  {
    name: 'CF',
    code: '236',
    label: 'Central African Republic',
  },
  {
    name: 'TD',
    code: '235',
    label: 'Chad',
  },
  {
    name: 'CL',
    code: '56',
    label: 'Chile',
  },
  {
    name: 'CN',
    code: '86',
    label: 'China',
  },
  {
    name: 'CX',
    code: '61',
    label: 'Christmas Island',
  },
  {
    name: 'CC',
    code: '891',
    label: 'Cocos (Keeling) Islands',
  },
  {
    name: 'CO',
    code: '57',
    label: 'Colombia',
  },
  {
    name: 'KM',
    code: '269',
    label: 'Comoros',
  },
  {
    name: 'CG',
    code: '242',
    label: 'Congo',
  },
  {
    name: 'CD',
    code: '242',
    label: 'Congo (Democratic Republic of the)',
  },
  {
    name: 'CK',
    code: '682',
    label: 'Cook Islands',
  },
  {
    name: 'CR',
    code: '506',
    label: 'Costa Rica',
  },
  {
    name: 'HR',
    code: '385',
    label: 'Croatia',
  },
  {
    name: 'CU',
    code: '53',
    label: 'Cuba',
  },
  {
    name: 'CW',
    code: '599',
    label: 'Curaçao',
  },
  {
    name: 'CY',
    code: '357',
    label: 'Cyprus',
  },
  {
    name: 'CZ',
    code: '420',
    label: 'Czech Republic',
  },
  {
    name: 'CI',
    code: '225',
    label: "Côte d'Ivoire",
  },
  {
    name: 'DK',
    code: '45',
    label: 'Denmark',
  },
  {
    name: 'DJ',
    code: '253',
    label: 'Djibouti',
  },
  {
    name: 'DM',
    code: '1',
    label: 'Dominica',
  },
  {
    name: 'DO',
    code: '1',
    label: 'Dominican Republic',
  },
  {
    name: 'EC',
    code: '593',
    label: 'Ecuador',
  },
  {
    name: 'EG',
    code: '20',
    label: 'Egypt',
  },
  {
    name: 'SV',
    code: '503',
    label: 'El Salvador',
  },
  {
    name: 'GQ',
    code: '240',
    label: 'Equatorial Guinea',
  },
  {
    name: 'ER',
    code: '291',
    label: 'Eritrea',
  },
  {
    name: 'EE',
    code: '372',
    label: 'Estonia',
  },
  {
    name: 'ET',
    code: '251',
    label: 'Ethiopia',
  },
  {
    name: 'FK',
    code: '500',
    label: 'Falkland Islands (Malvinas)',
  },
  {
    name: 'FO',
    code: '298',
    label: 'Faroe Islands',
  },
  {
    name: 'FJ',
    code: '679',
    label: 'Fiji',
  },
  {
    name: 'FI',
    code: '358',
    label: 'Finland',
  },
  {
    name: 'FR',
    code: '33',
    label: 'France',
  },
  {
    name: 'GF',
    code: '594',
    label: 'French Guiana',
  },
  {
    name: 'PF',
    code: '689',
    label: 'French Polynesia',
  },
  {
    name: 'TF',
    code: '262',
    label: 'French Southern Territories',
  },
  {
    name: 'GA',
    code: '241',
    label: 'Gabon',
  },
  {
    name: 'GM',
    code: '220',
    label: 'Gambia',
  },
  {
    name: 'GE',
    code: '995',
    label: 'Georgia',
  },
  {
    name: 'DE',
    code: '49',
    label: 'Germany',
  },
  {
    name: 'GH',
    code: '233',
    label: 'Ghana',
  },
  {
    name: 'GI',
    code: '350',
    label: 'Gibraltar',
  },
  {
    name: 'GR',
    code: '30',
    label: 'Greece',
  },
  {
    name: 'GL',
    code: '299',
    label: 'Greenland',
  },
  {
    name: 'GD',
    code: '1',
    label: 'Grenada',
  },
  {
    name: 'GP',
    code: '590',
    label: 'Guadeloupe',
  },
  {
    name: 'GU',
    code: '1',
    label: 'Guam',
  },
  {
    name: 'GT',
    code: '502',
    label: 'Guatemala',
  },
  {
    name: 'GG',
    code: '44',
    label: 'Guernsey',
  },
  {
    name: 'GN',
    code: '224',
    label: 'Guinea',
  },
  {
    name: 'GW',
    code: '245',
    label: 'Guinea-Bissau',
  },
  {
    name: 'GY',
    code: '592',
    label: 'Guyana',
  },
  {
    name: 'HT',
    code: '509',
    label: 'Haiti',
  },
  {
    name: 'HM',
    code: '0',
    label: 'Heard Island and McDonald Islands',
  },
  {
    name: 'VA',
    code: '379',
    label: 'Holy See',
  },
  {
    name: 'HN',
    code: '504',
    label: 'Honduras',
  },
  {
    name: 'HK',
    code: '852',
    label: 'Hong Kong',
  },
  {
    name: 'HU',
    code: '36',
    label: 'Hungary',
  },
  {
    name: 'IS',
    code: '354',
    label: 'Iceland',
  },
  {
    name: 'IN',
    code: '91',
    label: 'India',
  },
  {
    name: 'ID',
    code: '62',
    label: 'Indonesia',
  },
  {
    name: 'IQ',
    code: '964',
    label: 'Iraq',
  },
  {
    name: 'IE',
    code: '353',
    label: 'Ireland',
  },
  {
    name: 'IM',
    code: '44',
    label: 'Isle of Man',
  },
  {
    name: 'IL',
    code: '972',
    label: 'Israel',
  },
  {
    name: 'IT',
    code: '39',
    label: 'Italy',
  },
  {
    name: 'JM',
    code: '1',
    label: 'Jamaica',
  },
  {
    name: 'JP',
    code: '81',
    label: 'Japan',
  },
  {
    name: 'JE',
    code: '44',
    label: 'Jersey',
  },
  {
    name: 'JO',
    code: '962',
    label: 'Jordan',
  },
  {
    name: 'KZ',
    code: '7',
    label: 'Kazakhstan',
  },
  {
    name: 'KE',
    code: '254',
    label: 'Kenya',
  },
  {
    name: 'KI',
    code: '686',
    label: 'Kiribati',
  },
  {
    name: 'KR',
    code: '82',
    label: 'Korea (Republic of)',
  },
  {
    name: 'XK',
    code: '383',
    label: 'Kosovo',
  },
  {
    name: 'KW',
    code: '965',
    label: 'Kuwait',
  },
  {
    name: 'KG',
    code: '996',
    label: 'Kyrgyzstan',
  },
  {
    name: 'LA',
    code: '856',
    label: "Lao People's Democratic Republic",
  },
  {
    name: 'LV',
    code: '371',
    label: 'Latvia',
  },
  {
    name: 'LB',
    code: '961',
    label: 'Lebanon',
  },
  {
    name: 'LS',
    code: '266',
    label: 'Lesotho',
  },
  {
    name: 'LR',
    code: '231',
    label: 'Liberia',
  },
  {
    name: 'LY',
    code: '218',
    label: 'Libya',
  },
  {
    name: 'LI',
    code: '423',
    label: 'Liechtenstein',
  },
  {
    name: 'LT',
    code: '370',
    label: 'Lithuania',
  },
  {
    name: 'LU',
    code: '352',
    label: 'Luxembourg',
  },
  {
    name: 'MO',
    code: '853',
    label: 'Macao',
  },
  {
    name: 'MK',
    code: '389',
    label: 'Macedonia (the former Yugoslav Republic of)',
  },
  {
    name: 'MG',
    code: '261',
    label: 'Madagascar',
  },
  {
    name: 'MW',
    code: '265',
    label: 'Malawi',
  },
  {
    name: 'MY',
    code: '60',
    label: 'Malaysia',
  },
  {
    name: 'MV',
    code: '960',
    label: 'Maldives',
  },
  {
    name: 'ML',
    code: '223',
    label: 'Mali',
  },
  {
    name: 'MT',
    code: '356',
    label: 'Malta',
  },
  {
    name: 'MH',
    code: '692',
    label: 'Marshall Islands',
  },
  {
    name: 'MQ',
    code: '596',
    label: 'Martinique',
  },
  {
    name: 'MR',
    code: '222',
    label: 'Mauritania',
  },
  {
    name: 'MU',
    code: '230',
    label: 'Mauritius',
  },
  {
    name: 'YT',
    code: '269',
    label: 'Mayotte',
  },
  {
    name: 'MX',
    code: '52',
    label: 'Mexico',
  },
  {
    name: 'FM',
    code: '691',
    label: 'Micronesia (Federated States of)',
  },
  {
    name: 'MD',
    code: '373',
    label: 'Moldova (Republic of)',
  },
  {
    name: 'MC',
    code: '377',
    label: 'Monaco',
  },
  {
    name: 'MN',
    code: '976',
    label: 'Mongolia',
  },
  {
    name: 'ME',
    code: '382',
    label: 'Montenegro',
  },
  {
    name: 'MS',
    code: '1',
    label: 'Montserrat',
  },
  {
    name: 'MA',
    code: '212',
    label: 'Morocco',
  },
  {
    name: 'MZ',
    code: '258',
    label: 'Mozambique',
  },
  {
    name: 'MM',
    code: '95',
    label: 'Myanmar',
  },
  {
    name: 'NA',
    code: '264',
    label: 'Namibia',
  },
  {
    name: 'NR',
    code: '674',
    label: 'Nauru',
  },
  {
    name: 'NP',
    code: '977',
    label: 'Nepal',
  },
  {
    name: 'NL',
    code: '31',
    label: 'Netherlands',
  },
  {
    name: 'NC',
    code: '687',
    label: 'New Caledonia',
  },
  {
    name: 'NZ',
    code: '64',
    label: 'New Zealand',
  },
  {
    name: 'NI',
    code: '505',
    label: 'Nicaragua',
  },
  {
    name: 'NE',
    code: '227',
    label: 'Niger',
  },
  {
    name: 'NG',
    code: '234',
    label: 'Nigeria',
  },
  {
    name: 'NU',
    code: '683',
    label: 'Niue',
  },
  {
    name: 'NF',
    code: '672',
    label: 'Norfolk Island',
  },
  {
    name: 'MP',
    code: '1',
    label: 'Northern Mariana Islands',
  },
  {
    name: 'NO',
    code: '47',
    label: 'Norway',
  },
  {
    name: 'OM',
    code: '968',
    label: 'Oman',
  },
  {
    name: 'PK',
    code: '92',
    label: 'Pakistan',
  },
  {
    name: 'PW',
    code: '680',
    label: 'Palau',
  },
  {
    name: 'PS',
    code: '970',
    label: 'Palestine, State of',
  },
  {
    name: 'PA',
    code: '507',
    label: 'Panama',
  },
  {
    name: 'PG',
    code: '675',
    label: 'Papua New Guinea',
  },
  {
    name: 'PY',
    code: '595',
    label: 'Paraguay',
  },
  {
    name: 'PE',
    code: '51',
    label: 'Peru',
  },
  {
    name: 'PH',
    code: '63',
    label: 'Philippines',
  },
  {
    name: 'PN',
    code: '872',
    label: 'Pitcairn',
  },
  {
    name: 'PL',
    code: '48',
    label: 'Poland',
  },
  {
    name: 'PT',
    code: '351',
    label: 'Portugal',
  },
  {
    name: 'PR',
    code: '1',
    label: 'Puerto Rico',
  },
  {
    name: 'QA',
    code: '974',
    label: 'Qatar',
  },
  {
    name: 'RO',
    code: '40',
    label: 'Romania',
  },
  {
    name: 'RU',
    code: '7',
    label: 'Russian Federation',
  },
  {
    name: 'RW',
    code: '250',
    label: 'Rwanda',
  },
  {
    name: 'RE',
    code: '262',
    label: 'Réunion',
  },
  {
    name: 'BL',
    code: '590',
    label: 'Saint Barthélemy',
  },
  {
    name: 'SH',
    code: '290',
    label: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    name: 'KN',
    code: '1',
    label: 'Saint Kitts and Nevis',
  },
  {
    name: 'LC',
    code: '1',
    label: 'Saint Lucia',
  },
  {
    name: 'MF',
    code: '590',
    label: 'Saint Martin (French part)',
  },
  {
    name: 'PM',
    code: '508',
    label: 'Saint Pierre and Miquelon',
  },
  {
    name: 'VC',
    code: '1',
    label: 'Saint Vincent and the Grenadines',
  },
  {
    name: 'WS',
    code: '685',
    label: 'Samoa',
  },
  {
    name: 'SM',
    code: '378',
    label: 'San Marino',
  },
  {
    name: 'ST',
    code: '239',
    label: 'Sao Tome and Principe',
  },
  {
    name: 'SA',
    code: '966',
    label: 'Saudi Arabia',
  },
  {
    name: 'SN',
    code: '221',
    label: 'Senegal',
  },
  {
    name: 'RS',
    code: '381',
    label: 'Serbia',
  },
  {
    name: 'SC',
    code: '248',
    label: 'Seychelles',
  },
  {
    name: 'SL',
    code: '232',
    label: 'Sierra Leone',
  },
  {
    name: 'SG',
    code: '65',
    label: 'Singapore',
  },
  {
    name: 'SX',
    code: '1',
    label: 'Sint Maarten (Dutch part)',
  },
  {
    name: 'SK',
    code: '421',
    label: 'Slovakia',
  },
  {
    name: 'SI',
    code: '386',
    label: 'Slovenia',
  },
  {
    name: 'SB',
    code: '677',
    label: 'Solomon Islands',
  },
  {
    name: 'SO',
    code: '252',
    label: 'Somalia',
  },
  {
    name: 'ZA',
    code: '27',
    label: 'South Africa',
  },
  {
    name: 'GS',
    code: '500',
    label: 'South Georgia and the South Sandwich Islands',
  },
  {
    name: 'SS',
    code: '211',
    label: 'South Sudan',
  },
  {
    name: 'ES',
    code: '34',
    label: 'Spain',
  },
  {
    name: 'LK',
    code: '94',
    label: 'Sri Lanka',
  },
  {
    name: 'SD',
    code: '249',
    label: 'Sudan',
  },
  {
    name: 'SR',
    code: '597',
    label: 'Suriname',
  },
  {
    name: 'SJ',
    code: '47',
    label: 'Svalbard and Jan Mayen',
  },
  {
    name: 'SZ',
    code: '268',
    label: 'Swaziland',
  },
  {
    name: 'SE',
    code: '46',
    label: 'Sweden',
  },
  {
    name: 'CH',
    code: '41',
    label: 'Switzerland',
  },
  {
    name: 'SY',
    code: '963',
    label: 'Syrian Arab Republic',
  },
  {
    name: 'TW',
    code: '886',
    label: 'Taiwan, Province of China',
  },
  {
    name: 'TJ',
    code: '992',
    label: 'Tajikistan',
  },
  {
    name: 'TZ',
    code: '255',
    label: 'Tanzania, United Republic of',
  },
  {
    name: 'TH',
    code: '66',
    label: 'Thailand',
  },
  {
    name: 'TL',
    code: '670',
    label: 'Timor-Leste',
  },
  {
    name: 'TG',
    code: '228',
    label: 'Togo',
  },
  {
    name: 'TK',
    code: '690',
    label: 'Tokelau',
  },
  {
    name: 'TO',
    code: '676',
    label: 'Tonga',
  },
  {
    name: 'TT',
    code: '1',
    label: 'Trinidad and Tobago',
  },
  {
    name: 'TN',
    code: '216',
    label: 'Tunisia',
  },
  {
    name: 'TR',
    code: '90',
    label: 'Turkey',
  },
  {
    name: 'TM',
    code: '993',
    label: 'Turkmenistan',
  },
  {
    name: 'TC',
    code: '1',
    label: 'Turks and Caicos Islands',
  },
  {
    name: 'TV',
    code: '688',
    label: 'Tuvalu',
  },
  {
    name: 'UG',
    code: '256',
    label: 'Uganda',
  },
  {
    name: 'UA',
    code: '380',
    label: 'Ukraine',
  },
  {
    name: 'AE',
    code: '971',
    label: 'United Arab Emirates',
  },
  {
    name: 'GB',
    code: '44',
    label: 'United Kingdom of Great Britain and Northern Ireland',
  },
  {
    name: 'UM',
    code: '699',
    label: 'United States Minor Outlying Islands',
  },
  {
    name: 'UY',
    code: '598',
    label: 'Uruguay',
  },
  {
    name: 'VU',
    code: '678',
    label: 'Vanuatu',
  },
  {
    name: 'VE',
    code: '58',
    label: 'Venezuela (Bolivarian Republic of)',
  },
  {
    name: 'VN',
    code: '84',
    label: 'Viet Nam',
  },
  {
    name: 'VG',
    code: '1',
    label: 'Virgin Islands (British)',
  },
  {
    name: 'VI',
    code: '1',
    label: 'Virgin Islands (U.S.)',
  },
  {
    name: 'WF',
    code: '681',
    label: 'Wallis and Futuna',
  },
  {
    name: 'EH',
    code: '212',
    label: 'Western Sahara',
  },
  {
    name: 'YE',
    code: '967',
    label: 'Yemen',
  },
  {
    name: 'ZM',
    code: '260',
    label: 'Zambia',
  },
  {
    name: 'ZW',
    code: '263',
    label: 'Zimbabwe',
  },
  {
    name: 'AX',
    code: '358',
    label: 'Åland Islands',
  },
]

export default countryCodes
